var useEffect = require('react').useEffect;

var useOutboundClickListener = function useOutboundClickListener(matomoInstance) {
    var handleOutboundClick = function handleOutboundClick(event) {
        var findLinkElement = function findLinkElement(el) {
            if (el instanceof HTMLAnchorElement && el.href) {
                return el;
            }
            if (el instanceof HTMLElement && el.parentElement) {
                return findLinkElement(el.parentElement);
            }
            return null;
        };
        var target = findLinkElement(event.target);
        if (!(target instanceof HTMLAnchorElement)) {
            return;
        }
        var href = target.href;
        if (!href.match(new RegExp("^(http://www.|https://www.|http://|https://)+(" + window.location.hostname + ")"))) {
            matomoInstance.trackLink({ href: href });
        }
    };
    useEffect(function () {
        window.document.addEventListener('click', handleOutboundClick, {
            capture: true
        });
        return function () {
            window.document.removeEventListener('click', handleOutboundClick, {
                capture: true
            });
        };
    }, []);
};

module.exports = useOutboundClickListener;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@datapunt/matomo-tracker-react/es/utils/useOutboundClickListener.js
// module id = 773
// module chunks = 0